import styled from 'styled-components'

export const MinLoadginContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: #1d3056;
`
